module.exports = __webpack_public_path__ + "static/media/swingSubImg3.b07a664c.png";